module.exports = __webpack_public_path__ + "static/about-2-4b58d06aeb4d63b0937ca6adc81aafb8.jpg";